export default __webpack_public_path__ + "static/docker-6d1afdb456643d6031423e71908adb98.png";